import { onUnmounted, reactive, watch } from '@vue/composition-api';
import "../style/common/common.css"; // 全局的，多实例的lock

var lockCount = 0;
var hiddenClass = 'm-overflow-hidden';
export function useLockScroll(isLock) {
  var state = reactive({
    isLock: false
  });
  var lock = function lock() {
    lockCount++;
    var locked = document.body.classList.contains(hiddenClass);
    if (!locked && lockCount) {
      document.body.classList.add(hiddenClass);
    }
  };
  var unlock = function unlock() {
    lockCount--;
    var locked = document.body.classList.contains(hiddenClass);
    if (locked && !lockCount) {
      document.body.classList.remove(hiddenClass);
    }
  };
  watch(isLock, function (isLock, isPreLock) {
    state.isLock = isLock;
    if (isLock) {
      lock();
    } else if (typeof isPreLock !== 'undefined') {
      unlock();
    }
    var locked = document.body.classList.contains(hiddenClass);
    console.log('lock: ', isLock, isPreLock, ', lock count: ', lockCount, ', locked: ', locked);
  }, {
    immediate: true
  });
  onUnmounted(function () {
    if (state.isLock) {
      unlock();
    }
  });
}